import LinearChart from '../singleFund/LinearChart';
import { graphConfig } from '../../constants/graphConfig';

const formatGraphData = (data) => {
  return data.map((point) => {
    const timestamp = new Date(point.x).getTime();
    return [timestamp, point.y];
  });
};
export const FundPerformanceChart = ({
  fundPerformaceData,
  catgPerformaceData,
  category,
  name,
}) => {
  return (
    <div className="lil-pt-6 sm:lil-pt-0">
      <LinearChart
        graphData={formatGraphData(fundPerformaceData)}
        categoryData={formatGraphData(catgPerformaceData)}
        graphConfig={graphConfig}
        category={category}
        name={name}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/fundPerformanceChart.tsx